import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import styles from './PdpSharedPromoCode.scss';
import classnames from 'classnames';
import {
    TRADE_WELCOME_PROMO_CODE,
    TRADE_FIRST_WELCOME_PROMO_CODE,
} from 'dibs-buyer-layout/exports/tradePromoConstants';

import { PromoCodeLoader } from '../../global/PromoCodeLoader';
import { TradePromoLoader } from '../../global/TradePromo/TradePromoLoader';

export const PdpSharedPromoCodeComponent = ({
    viewer,
    user,
    userId,
    itemId,
    displayInfo,
    relay,
    onlyShippingPromos,
    excludeShippingPromos,
    currency,
    containerClass = '',
}) => {
    if (!displayInfo && !onlyShippingPromos) {
        return null;
    }

    const tradeFirm = user?.tradeFirm;
    const userLevelPromo = viewer?.activePromotion;
    const userLevelPromoCode = userLevelPromo?.code;
    const hasFirmLevelPromo = tradeFirm?.rewards?.currentPromoSegment?.segmentCode;
    const hasTradeUserPromo = [TRADE_WELCOME_PROMO_CODE, TRADE_FIRST_WELCOME_PROMO_CODE].includes(
        userLevelPromoCode
    );

    // if there is no user-level promo, render this for trade users so points-earned messaging appears
    if (hasTradeUserPromo || (tradeFirm && (hasFirmLevelPromo || !userLevelPromo))) {
        return <TradePromoLoader user={user} />;
    }

    const showSalePrice = displayInfo?.pricing?.showSale;
    const showNetPrice = displayInfo?.pricing?.showNet;

    const containerClasses = classnames(containerClass, styles.container, {
        [styles.onlyShippingPromosContainer]: onlyShippingPromos,
    });

    return (
        <PromoCodeLoader
            load
            transaction={null}
            environment={relay.environment}
            userId={userId}
            itemId={itemId}
            isFurtherReduced={showSalePrice || showNetPrice}
            containerClass={containerClasses}
            displaySingleLine
            onlyShippingPromos={onlyShippingPromos}
            excludeShippingPromos={excludeShippingPromos}
            currency={currency}
        />
    );
};

PdpSharedPromoCodeComponent.propTypes = {
    user: PropTypes.object,
    userId: PropTypes.string,
    item: PropTypes.object,
    itemId: PropTypes.string,
    displayInfo: PropTypes.object,
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object,
    onlyShippingPromos: PropTypes.bool,
    excludeShippingPromos: PropTypes.bool,
    currency: PropTypes.string,
    containerClass: PropTypes.string,
};

export const PdpSharedPromoCode = createFragmentContainer(PdpSharedPromoCodeComponent, {
    viewer: graphql`
        fragment PdpSharedPromoCode_viewer on Viewer {
            activePromotion(userId: $userId, itemId: $itemId) {
                code
            }
        }
    `,
    displayInfo: graphql`
        fragment PdpSharedPromoCode_displayInfo on ItemDisplayInfo {
            pricing {
                showSale
                showNet
            }
        }
    `,
    user: graphql`
        fragment PdpSharedPromoCode_user on User {
            ...TradePromo_user @include(if: $isTrade)
            tradeFirm @include(if: $isTrade) {
                rewards {
                    currentPromoSegment(userId: $userId) {
                        segmentCode
                    }
                }
            }
        }
    `,
});
